/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Auth_Token_LabelInputs */

const cs_import_auth_token_label = /** @type {(inputs: Import_Auth_Token_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IT token pro import`)
};

const en_import_auth_token_label = /** @type {(inputs: Import_Auth_Token_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IT import token`)
};

/**
* | output |
* | --- |
* | "IT import token" |
*
* @param {Import_Auth_Token_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_auth_token_label = /** @type {((inputs?: Import_Auth_Token_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Auth_Token_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_auth_token_label(inputs)
	return cs_import_auth_token_label(inputs)
});